export default function getLastLineCharacter (str) {
  const lastIndex = str.lastIndexOf('\n')

  if (lastIndex < 0) {
    return str.length
  }

  return str.substr(lastIndex + 1).length
}
